































import { defineComponent, PropType, ref, computed, set } from "@vue/composition-api";
import draggable from "vuedraggable";
import { PostFileData } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseIconButton from "@/components/BaseIconButton";
import { DraggableEmitOptions } from "@/components/PostCreate/types";
import DraggableFilePreview from "./components/DraggableFilePreview";

export default defineComponent({
  name: "PostDraggableView",
  components: {
    BaseIconButton,
    BaseButton,
    DraggableFilePreview,
    draggable,
  },
  props: {
    fileList: { type: Array as PropType<PostFileData[]>, required: true },
    showPublicAccessToggle: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const list = ref<PostFileData[]>(props.fileList);

    const idList = computed(() => list.value.map(i => i.id));
    const draggableOptions: Record<string, string | boolean | number> = {
      delay: 200,
      animation: 200,
      delayOnTouchOnly: true,
      supportPointer: false,
      dragClass: "post-draggable__dragging",
      ghostClass: "post-draggable__ghost",
    };

    const onUpdateDraggable = ({ newDraggableIndex, oldDraggableIndex }: DraggableEmitOptions) => {
      list.value.splice(newDraggableIndex, 0, list.value.splice(oldDraggableIndex, 1)[0]);
    };

    const onReverse = () => {
      list.value.reverse();
    };

    const onReorder = () => {
      emit("reorder", idList.value);
    };

    const onFileChange = (file: PostFileData) => {
      const index = list.value.findIndex(i => i.id === file.id);
      if (index !== -1) {
        emit("file:change", { id: file.id, publicAccess: !file.public });
        set(list.value[index], "public", !file.public);
      }
    };

    return { list, draggableOptions, onUpdateDraggable, onReorder, onReverse, onFileChange };
  },
});
